module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: (_vm.styleObject)
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bbb51146!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-instant-pdf-viewer/src/VuePDFViewer.vue
// module id = 1124
// module chunks = 1